import { render, staticRenderFns } from "./UpdateMsg.vue?vue&type=template&id=16e32610&scoped=true"
import script from "./UpdateMsg.vue?vue&type=script&lang=js"
export * from "./UpdateMsg.vue?vue&type=script&lang=js"
import style0 from "./UpdateMsg.vue?vue&type=style&index=0&id=16e32610&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e32610",
  null
  
)

export default component.exports